import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class SalesOrderService {
    [x: string]: any;
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/salesOrder';
    private masterUrl = 'api/workorder'
    private paymentVoucherUrl = 'api/paymentVoucher';
    private shirtStock = 'api/shirtStock';
    private CoreGangOrderPending = 'api/coreGangPendingOrder';
    private newPendingOrder = 'api/newPendingOrder';
    private soPrintUrl ='api/print';
    private autoUrl = "api/autoNumber";  // URL to web api
    private salesUrl = 'api/salesplan1';
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }
    private htmlData(res: any) {
        let body = res._body;
        return body || [];
    }

    getFinYearList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getfinList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    plainSoreport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/plainSoreport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getcountersalesDC(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getcountersalesDC`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getcountCustomer(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getcountCustomer`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    counterprint(partyData: any): Promise<any> {
        const url = `http://localhost/thermal_print/api/print`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    counterDcprint(partyData: any): Promise<any> {
        const url = `http://localhost/thermal_print/api/DCprint`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    sizelimitStkprint(partyData: any): Promise<any> {
        const url = `http://localhost/thermal_print/api/limitStkprint`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getDesignWiseCounter(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignWiseCounter`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getPartyWiseCounter(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getPartyWiseCounter`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    custDeliveryReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/custDeliveryReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getcounterdcList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getcounterdcList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getcounterTransfer(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getcounterTransfer`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getCurrentpageState(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getCurrentpageState`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    controlsalesPage(itemData: any): Promise<any[]> {
       const url = `${this.Url}/controlsalesPage`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    salesOrderList(itemData: any): Promise<any[]> {
        const url = `${this.Url}/salesOrderList`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    updateSalesstate(itemData: any): Promise<any[]> {
        const url = `${this.Url}/updateSalesstate`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
   
    viewCommissionlist(itemData: any): Promise<any[]> {
        const url = `${this.Url}/viewCommissionlist`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    getBrandStockInwardList(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getBrandStockInwardList`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    getCoreGangDesignList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.CoreGangOrderPending}/getCoreGangDesignList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getNewDesignList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPendingOrder}/getNewDesignList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getDesignPhotoOrderForm(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignPhotoOrderForm`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getOpenOrderReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getOpenOrderReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getShirtStockReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.shirtStock}/getShirtStockReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    gettextileStockReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.shirtStock}/gettextileStockReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getCoreGangPendingOrder(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.CoreGangOrderPending}/getCoreGangPendingOrder`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getPartyOrderPendingVsStock(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.CoreGangOrderPending}/getPartyOrderPendingVsStock`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getSalesOrderCancelAndPend(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.CoreGangOrderPending}/getSalesOrderCancelAndPend`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    updateSalesOrderCancel(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {

            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.CoreGangOrderPending}/updateSalesOrderCancel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }   
    chqreturnList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/chqreturnList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    salesRetList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/salesRetList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    specialPartiesList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/specialPartiesList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    getNewPendingOrder(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPendingOrder}/getNewPendingOrder`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    printOrder(itemData: any): Promise<any[]> {
        

        let params: URLSearchParams = new URLSearchParams();
        for (let key in itemData) {
            params.set(key.toString(), itemData[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.soPrintUrl}/orderPrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
     }

    getAutoNumber(itemData: any): Promise<any[]> {
       const url = `${this.autoUrl}/getAutoNumber`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getCourierAuto(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getCourierAuto`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    
    getAutoNoBrandStock(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getAutoNoBrandStock`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }

     getDesignsToDefault(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getDesignsToDefault`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }

     getMasterAuto(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getMasterAuto`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getPaymantAuto(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getPaymantAuto`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     GetCountdcAuto(itemData: any): Promise<any[]> {
        const url = `${this.Url}/GetCountdcAuto`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
     }
     getAgentPendingCommission(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getAgentPendingCommission`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getAutoPaymentVoucher(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getAutoPaymentVoucher`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getAutoDedNum(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getAutoDedNum`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getBillPendingDetails(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getBillPendingDetails`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }

     
    // display agent list
    addAgent(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/agentlist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


     getAgentBills(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getAgentBills`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     onSaveAgentDet(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/onSaveAgentDet`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     
     getViewPaymentVoucherList(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getViewPaymentVoucherList`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     saveBillDetails(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/saveBillDetails`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     addCourierDet(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/addCourierDet`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     
     chequeReturnDetails(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/chequeReturnDetails`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }

     getPaymentVoucherDetails(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/getPaymentVoucherDetails`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    adduptSalesOrder(itemData: any): Promise<any[]> {
       const url = `${this.Url}/adduptSalesOrder`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveCourierPayment(itemData: any): Promise<any[]> {
        const url = `${this.paymentVoucherUrl}/saveCourierPayment`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    adduptBrandStockInward(itemData: any): Promise<any[]> {
        const url = `${this.Url}/adduptBrandStockInward`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    getOrderData(itemData: any): Promise<any[]> {
        const url = `${this.Url}/getOrderData`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    getSeasonAgentList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSeasonAgentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getSalesPlanList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSalesPlanList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    savePlan(itemData: any): Promise<any> {
        const url = `${this.Url}/addUpdateSales`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSoEntryGridShirtSizeDet(partyData: any): Promise<any> {
        const url = `${this.Url}/getSoEntryGridShirtSizeDet`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getViewBrandListeDet(partyData: any): Promise<any> {
        const url = `${this.Url}/getViewBrandListeDet`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
   
    onSaveSalesPlan(partyData: any): Promise<any> {
        const url = `${this.Url}/onSaveSalesPlan`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
  
    addMasterCommission(itemData: any): Promise<any[]> {
        const url = `${this.Url}/addMasterCommission`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     addFactorydelPlan(itemData: any): Promise<any[]> {
        const url = `${this.masterUrl}/addFactorydelPlan`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     } 
     addFactoryProdPlan(itemData: any): Promise<any[]> {
        const url = `${this.masterUrl}/addFactoryProdPlan`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     } 
     addPaymentEntry(itemData: any): Promise<any[]> {
        const url = `${this.Url}/addPaymentEntry`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     SaveCounterdc(itemData: any): Promise<any[]> {
        const url = `${this.Url}/SaveCounterdc`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     SavecounterTransferdC(itemData: any): Promise<any[]> {
        const url = `${this.Url}/SavecounterTransferdC`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     SaveCustomerCount(itemData: any): Promise<any[]> {
        const url = `${this.Url}/SaveCustomerCount`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     SaveDesignWiseCounter(itemData: any): Promise<any[]> {
        const url = `${this.Url}/SaveDesignWiseCounter`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     SavePartyWiseCounter(itemData: any): Promise<any[]> {
        const url = `${this.Url}/SavePartyWiseCounter`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     Savecounterdcentry(itemData: any): Promise<any[]> {
        const url = `${this.Url}/Savecounterdcentry`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     addCounterstock(itemData: any): Promise<any[]> {
        const url = `${this.Url}/addCounterstock`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     MovetoConvertstock(itemData: any): Promise<any[]> {
        const url = `${this.Url}/MovetoConvertstock`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getcommissionMasterList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getcommissionMasterList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getFactoryProdplanList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });
        const url = `${this.masterUrl}/getFactoryProdplanList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getFactoryDelplanList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.masterUrl}/getFactoryDelplanList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getagentPaymentEntryList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getagentPaymentEntryList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    getAgentList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getAgentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getSeasonList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSeasonList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getTargetList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getTargetList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getCourierList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/getCourierList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    geViewInwardPDCist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/geViewInwardPDCist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    getPDCList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.paymentVoucherUrl}/getPDCList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getSalesPlanDetails(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getSalesPlanDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }
    updatedepositDet(itemData: any): Promise<any> {
        const url = `${this.paymentVoucherUrl}/updatedepositDet`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    updatepassDet(itemData: any): Promise<any> {
        const url = `${this.paymentVoucherUrl}/updatepassDet`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    delsalesOrder(itemData: any): Promise<any> {
        const url = `${this.Url}/delSalesOrder`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    boxprintModal(itemData: any): Promise<any> {
        const url = `${this.Url}/boxprintModal`;
        return this.http
            .post(url, $.param(itemData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    DeletecounterDC(itemData: any): Promise<any[]> {
        const url = `${this.Url}/DeletecounterDC`;
         return this.http
             .post(url, $.param(itemData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }

    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/salesOrder.service.ts